<main class="policy-page">
  <section class="policy-hero">
    <div class="policy-shell">
      <app-navigate-back class="mb-4"></app-navigate-back>
      <h1 class="policy-title">Terms &amp; Conditions</h1>
      <p class="policy-subtitle">Please read the Terms and Condition carefully</p>
    </div>
  </section>

  <section class="policy-body">
    <div class="policy-shell policy-copy prose prose-lg max-w-none text-[#0A0A0A] leading-relaxed">
    
    <div class="mb-8">
      <!-- <p class="text-base text-gray-600 mb-4">
        <strong>Last Updated:</strong> [Date to be added]
      </p> -->
      
      <p class="text-base text-justify mb-6">
        Welcome to Varroc Connect Private Limited ("Company", "we", "our", or "us"). By accessing or using our website and services, including software solutions, hardware products, and related support (collectively, the "Services"), you ("User", "you", or "your") agree to comply with and be bound by these Terms & Conditions ("Terms"). If you do not agree, please do not use our Services.
      </p>
    </div>

    <div class="mb-8">
      <h2 class="font-semibold text-xl mb-4 text-black">1. Eligibility</h2>
      <p class="text-base text-justify mb-4">
        You must be at least 18 years old and capable of entering legally binding contracts to use our Services. By using the Services, you represent that you meet these requirements.
      </p>
    </div>

    <div class="mb-8">
      <h2 class="font-semibold text-xl mb-4 text-black">2. Services Offered</h2>
      <p class="text-base text-justify mb-4">
        We provide software solutions, hardware products, integration, installation, maintenance, and related support. Specific features, functionalities, and availability may vary and are subject to change at our discretion.
      </p>
    </div>

    <div class="mb-8">
      <h2 class="font-semibold text-xl mb-4 text-black">3. User Responsibilities</h2>
      <ul class="list-disc list-inside ml-4 mb-4 space-y-2">
        <li class="text-base">Provide accurate, current, and complete information during registration or service requests.</li>
        <li class="text-base">Maintain the confidentiality of your account credentials.</li>
        <li class="text-base">Use the Services only for lawful purposes and in compliance with all applicable laws.</li>
        <li class="text-base">Not misuse, reverse-engineer, copy, or exploit our software, hardware, or intellectual property.</li>
      </ul>
    </div>

    <div class="mb-8">
      <h2 class="font-semibold text-xl mb-4 text-black">4. Orders, Payments, and Billing</h2>
      <ul class="list-disc list-inside ml-4 mb-4 space-y-2">
        <li class="text-base">Prices for products and services are listed on our website (subject to change without notice).</li>
        <li class="text-base">Payments must be made as per the agreed payment terms.</li>
        <li class="text-base">We may suspend or terminate services for non-payment.</li>
        <li class="text-base">Taxes, duties, and levies (if applicable) are the responsibility of the User.</li>
      </ul>
    </div>

    <div class="mb-8">
      <h2 class="font-semibold text-xl mb-4 text-black">5. Delivery & Installation</h2>
      <ul class="list-disc list-inside ml-4 mb-4 space-y-2">
        <li class="text-base">Hardware delivery timelines will be communicated at the time of order.</li>
        <li class="text-base">Installation and configuration services (if included) will be carried out by our authorized personnel.</li>
        <li class="text-base">Risk of loss passes to you upon delivery. Title to hardware remains with the Company until full payment is received.</li>
      </ul>
    </div>

    <div class="mb-8">
      <h2 class="font-semibold text-xl mb-4 text-black">6. Software License</h2>
      <ul class="list-disc list-inside ml-4 mb-4 space-y-2">
        <li class="text-base">We grant you a limited, non-exclusive, non-transferable, revocable license to use our software solely for your internal business purposes.</li>
        <li class="text-base">You may not sublicense, distribute, or modify the software without our prior written consent.</li>
      </ul>
    </div>

    <div class="mb-8">
      <h2 class="font-semibold text-xl mb-4 text-black">7. Maintenance and Support</h2>
      <ul class="list-disc list-inside ml-4 mb-4 space-y-2">
        <li class="text-base">Software updates, bug fixes, and patches will be provided as per the support plan purchased.</li>
        <li class="text-base">Hardware warranty and support terms will be detailed in your purchase order or invoice.</li>
      </ul>
    </div>

    <div class="mb-8">
      <h2 class="font-semibold text-xl mb-4 text-black">8. Intellectual Property Rights</h2>
      <p class="text-base text-justify mb-4">
        All intellectual property rights in our website, software, hardware designs, trademarks, and content remain exclusively with the Company. No rights are transferred except as expressly permitted under these Terms.
      </p>
    </div>

    <div class="mb-8">
      <h2 class="font-semibold text-xl mb-4 text-black">9. Confidentiality</h2>
      <p class="text-base text-justify mb-4">
        Any non-public information exchanged between you and us shall remain confidential and shall not be disclosed to third parties, except as required by law.
      </p>
    </div>

    <div class="mb-8">
      <h2 class="font-semibold text-xl mb-4 text-black">10. Data Protection & Privacy</h2>
      <p class="text-base text-justify mb-4">
        We respect your privacy. Our collection and use of personal data are governed by our Privacy Policy, which forms part of these Terms.
      </p>
    </div>

    <div class="mb-8">
      <h2 class="font-semibold text-xl mb-4 text-black">11. Third-Party Services</h2>
      <p class="text-base text-justify mb-4">
        Our Services may integrate with third-party products or platforms. We are not responsible for the availability, accuracy, or reliability of third-party services.
      </p>
    </div>

    <div class="mb-8">
      <h2 class="font-semibold text-xl mb-4 text-black">12. Limitation of Liability</h2>
      <p class="text-base text-justify mb-4">
        To the maximum extent permitted by law, our liability for any claim arising out of or relating to the Services shall be limited to the amount paid by you for the specific service/product giving rise to the claim.
      </p>
      
      <p class="text-base text-justify mb-4">
        We shall not be liable for indirect, incidental, special, or consequential damages, including loss of profit, data, or business opportunities.
      </p>
    </div>

    <div class="mb-8">
      <h2 class="font-semibold text-xl mb-4 text-black">13. Warranties & Disclaimers</h2>
      <ul class="list-disc list-inside ml-4 mb-4 space-y-2">
        <li class="text-base">Hardware products may carry manufacturer warranties as per applicable terms.</li>
        <li class="text-base">Software is provided "as is" without warranties of any kind, express or implied, except as specifically stated in writing.</li>
      </ul>
    </div>

    <div class="mb-8">
      <h2 class="font-semibold text-xl mb-4 text-black">14. Termination</h2>
      <p class="text-base text-justify mb-4">
        We may suspend or terminate your access to Services if you breach these Terms, fail to pay dues, or misuse our Services. Upon termination, your license to use our software immediately ends.
      </p>
    </div>

    <div class="mb-8">
      <h2 class="font-semibold text-xl mb-4 text-black">15. Governing Law & Jurisdiction</h2>
      <p class="text-base text-justify mb-4">
        These Terms shall be governed by and construed in accordance with the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts at Pune.
      </p>
    </div>

    <div class="mb-8">
      <h2 class="font-semibold text-xl mb-4 text-black">16. Amendments</h2>
      <p class="text-base text-justify mb-4">
        We reserve the right to update or modify these Terms at any time. The updated Terms will be posted on our website with the "Last Updated" date. Continued use of our Services after changes constitutes acceptance.
      </p>
    </div>

    <div class="mb-8">
      <h2 class="font-semibold text-xl mb-4 text-black">17. Contact Us</h2>
      <p class="text-base text-justify mb-4">
        For queries or concerns regarding these Terms, please contact us at:
      </p>
      
      <div class="ml-4 mb-4">
        <p class="text-base mb-2"><strong>Varroc Connect Private Limited:</strong></p>
        <p class="text-base mb-2"><strong>Email:</strong> <a [href]="'mailto:' + SupportEmail" class="text-blue-600 hover:text-blue-800 underline">{{SupportEmail}}</a></p>
        <p class="text-base mb-2"><strong>Phone:</strong> 9579292320</p>
        <p class="text-base mb-2"><strong>Address:</strong> Elpro International, Chinchwad Station Rd, Chinchwad Gaon, Chinchwad, Pimpri-Chinchwad, Maharashtra 411033</p>
      </div>
    </div>

    </div>
  </section>
</main>



